module.exports = __webpack_public_path__ + "static/media/abi.94f55877.jpg";